import { LOCALES } from '@/util/i18n/locale';

// A tenant-profile field holds a value per language: the primary `value` is in
// `entry.language`, and `entry.translations` carries the other-language values.
// Field languages are short codes ('fr' / 'en'); app locales are 'fr-CA' / 'en-CA'.

export const localeToLang = (locale) => (locale || '').split('-')[0];

// Selectable field languages, derived from the app locales.
export const FIELD_LANGUAGES = LOCALES.map((l) => ({ code: localeToLang(l.locale), name: l.name }));

// All { language, value } pairs a field carries (primary value first).
export const fieldLanguageValues = (entry) => {
  if (!entry) return [];
  const pairs = [];
  if (entry.language) pairs.push({ language: entry.language, value: entry.value });
  (entry.translations || []).forEach((t) => {
    if (t.language) pairs.push({ language: t.language, value: t.value });
  });
  return pairs;
};

// The value to show for a given language, or '' when the field has none.
export const fieldValueForLang = (entry, lang) => {
  const pair = fieldLanguageValues(entry).find((p) => p.language === lang);
  return pair ? pair.value : '';
};

// The value to display: the current locale's value when present, otherwise the
// field's primary value. Single-language fields therefore always show.
export const fieldDisplayValue = (entry, lang) => {
  const pairs = fieldLanguageValues(entry);
  const match = pairs.find((p) => p.language === lang);
  return ((match || pairs[0] || {}).value || '').toString();
};

// Whether the field has a value in the given language.
export const fieldHasLang = (entry, lang) => fieldLanguageValues(entry).some((p) => p.language === lang);
